export const REQUEST_ENDPOINT = `${process.env.REACT_APP_RIS_API_URL}/mid-market-report`;
